import { hqHalfyearTopics, type HqDashboardResult, type HqHistoricalSummary } from '@kop/contracts';
import type { HqHalfyearState } from './controller';
import { hqHalfyearStatusLabels } from './print';

/** Report judgements remain separate from the editor's review progress. */
export function hqHalfyearOriginalJudgements(historical: HqHistoricalSummary | null | undefined, year: number, half: 1 | 2) {
  if (!historical || historical.year !== year) return null;
  const reports = historical.halfyear.filter(report => report.half === half);
  if (reports.length !== 1 || reports[0]!.topics.length !== 10 ||
    new Set(reports[0]!.topics.map(topic => topic.id)).size !== 10) return null;
  return { reportDate: reports[0]!.reportDate,
    topics: new Map(reports[0]!.topics.map(topic => [topic.id, topic.originalJudgement])) };
}

/** Dashboard status comes only from the selected period's acknowledged document. */
export function hqHalfyearOverview(state: HqHalfyearState, year: number, half: 1 | 2) {
  const selected = state.document?.draft.year === year && state.document.draft.half === half;
  const document = !state.loading && !state.error && selected ? state.document : null;
  const message = state.error ? '조회 실패' : state.loading || !state.data ? '조회 중' : document ? `저장본 ${document.version}` : '미등록';
  return {
    message,
    savedAt: document?.savedAt ?? null,
    version: document?.version ?? null,
    topics: hqHalfyearTopics.map(topic => {
      const saved = document?.draft.topics.find(item => item.id === topic.id);
      return { id: topic.id, label: saved?.label ?? topic.label, status: saved?.status ?? null, state: saved ? hqHalfyearStatusLabels[saved.status] : message };
    }),
  };
}

/** Compact acknowledged save from the dashboard endpoint; no editor/source hydration on entry. */
export function hqHalfyearSavedOverview(data: Pick<HqDashboardResult, 'year' | 'half' | 'review' | 'reviewState'> | null, loading: boolean, error: boolean, year: number, half: 1 | 2) {
  const selected = data?.year === year && data.half === half;
  const review = !error && selected && data.reviewState === 'saved' ? data.review : null;
  const message = error || (selected && data.reviewState === 'invalid') ? '조회 실패'
    : loading || !selected ? '조회 중' : review ? `저장본 ${review.version}` : '미등록';
  return {
    message, savedAt: review?.savedAt ?? null, version: review?.version ?? null,
    topics: hqHalfyearTopics.map(topic => {
      const saved = review?.topics.find(item => item.id === topic.id);
      return { id: topic.id, label: saved?.label ?? topic.label, status: saved?.status ?? null,
        state: saved ? hqHalfyearStatusLabels[saved.status] : message };
    }),
  };
}
